<ng-container *ngIf="show">

  <!-- End of the report: the full card. The profile row also becomes this card
       on a computer, where a row would need an extra screen (the QR dialog) to
       reach the stores (Danna 26.09: same offer, the stores in one tap). -->
  <section class="adl-card" *ngIf="variant === 'card' || isDesktop">
    <div class="adl-body" [class.adl-body-desktop]="isDesktop">

      <div class="adl-qr" *ngIf="isDesktop">
        <qrcode
          [qrdata]="qrUrl"
          [width]="128"
          [margin]="1"
          [errorCorrectionLevel]="'M'"
          [colorDark]="'#1a1a2e'"
          [colorLight]="'#ffffff'"
          [alt]="'appDownload.title' | translate"
        ></qrcode>
      </div>

      <div class="adl-text">
        <h3 class="adl-title">{{ 'appDownload.title' | translate }}</h3>
        <p class="adl-sub">
          {{ (isDesktop ? 'appDownload.bodyDesktop' : 'appDownload.body') | translate }}
        </p>
        <p class="adl-note">{{ 'appDownload.signInNote' | translate }}</p>

        <div class="adl-badges">
          <a
            *ngIf="!isDesktop && os"
            class="adl-badge"
            [class.adl-badge-play]="os === 'android'"
            [href]="storeUrl(os)"
            (click)="track(os)"
            target="_blank"
            rel="noopener"
            [attr.aria-label]="(os === 'ios' ? 'appDownload.ariaAppStore' : 'appDownload.ariaGooglePlay') | translate"
          >
            <img [src]="badgeSrc(os)" alt="" />
          </a>

          <ng-container *ngIf="isDesktop">
            <a
              class="adl-badge"
              [href]="storeUrl('ios')"
              (click)="track('ios')"
              target="_blank"
              rel="noopener"
              [attr.aria-label]="'appDownload.ariaAppStore' | translate"
            >
              <img [src]="badgeSrc('ios')" alt="" />
            </a>
            <a
              class="adl-badge adl-badge-play"
              [href]="storeUrl('android')"
              (click)="track('android')"
              target="_blank"
              rel="noopener"
              [attr.aria-label]="'appDownload.ariaGooglePlay' | translate"
            >
              <img [src]="badgeSrc('android')" alt="" />
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </section>

  <!-- Profile: the quiet row -->
  <!-- On a phone one tap already opens her store, so the row stays a row, with
       the card's own title and copy (Danna 26.09: same offer, one size smaller). -->
  <button type="button" class="adl-row" *ngIf="variant === 'row' && !isDesktop" (click)="openRow()">
    <span class="adl-row-ico" aria-hidden="true">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="7" y="2" width="10" height="20" rx="2" />
        <line x1="11" y1="18" x2="13" y2="18" />
      </svg>
    </span>
    <span class="adl-row-text">
      <span class="adl-row-title">{{ 'appDownload.title' | translate }}</span>
      <span class="adl-row-sub">{{ 'appDownload.body' | translate }}</span>
      <span class="adl-row-sub adl-row-note">{{ 'appDownload.signInNote' | translate }}</span>
    </span>
    <span class="adl-row-chev" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </span>
  </button>

</ng-container>
